module.exports = __webpack_public_path__ + "static/media/Pebble.f5863c6a.woff2";